export const config = {
  admin: {
    email: process.env.REACT_APP_ADMIN_EMAIL || 'simone@sharly.ai',
    password: process.env.REACT_APP_ADMIN_PASSWORD || 'password123',
    name: 'System Administrator',
  },
  security: {
    minPasswordLength: 6,
  },
} as const;
